import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'saMatOptionDisplayWrapper' })
export class MatOptionDisplayWrapperPipe implements PipeTransform {
    transform(values, args: string[]): any {
        if (!values) {
            return [];
        }
        return values.map(p => ({ __sa_option_ui: {}, item: p }));
    }
}